module.exports = __webpack_public_path__ + "img/top0.e31e67f5.png";